<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{impactObj.titleImpact}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="ihse"
                  :label="this.localForm.ihse"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="health_and_safety"
                hint="safety"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="ifin"
                :label="this.localForm.ifin"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="paid"
                hint="finance"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="ienv"
                :label="this.localForm.ienv"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="eco"
                hint="environment"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="ibus"
                :label="this.localForm.ibus"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="work_outline"
                hint="business"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="isoc"
                :label="this.localForm.isoc"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="groups"
                hint="social"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select
                :change="updateFormChar()"
                v-model="irep"
                :label="this.localForm.irep"
                :items="riskConsequenceOptions"
                color="wplblue0"
                prepend-icon="star_half"
                hint="reputation"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="this.enableEventBarriersControls">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{impactObj.titleControl}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs10>
              <v-select
              v-model="barrier"
              :items="hazardBarrierOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="shield"
              hint="hazard barriers"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs10>
              <v-select
              v-model="control"
              :items="hazardControlOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="health_and_safety"
              hint="hazard controls"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{impactObj.titleDescription}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.impact"
              :disabled="false"
              :outline="true"
              :rules="mustBeLessThanLargeNotRequired"
              hint="actual impact assessment"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="this.enableEscalationOutcomes">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{impactObj.titleOutcome}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs10>
              <v-select
              v-model="outcome"
              :items="hazardOutcomeOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="share"
              hint="potential outcomes"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import incidentOptions from "@/data/options/mixins/incidentOptions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import hazardOptions from "@/data/options/mixins/hazardOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      localForm: {
        isoc: "",
        irep: "",
        ihse: "",
        ifin: "",
        ienv: "",
        ibus: "",
        impact: "",
        control: "",
        barrier: ""
      },
      orgForm: {
        isoc: "",
        irep: "",
        ihse: "",
        ifin: "",
        ienv: "",
        ibus: "",
        impact: "",
        control: "",
        barrier: "",
        outcome: ""
      },
      isoc: "",
      irep: "",
      ifin: "",
      ibus: "",
      ihse: "",
      ienv: "",
      control: "",
      barrier: "",
      outcome: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.isoc = this.getDetail.char.isoc;
    this.localForm.irep = this.getDetail.char.irep;
    this.localForm.ienv = this.getDetail.char.ienv;
    this.localForm.ibus = this.getDetail.char.ibus;
    this.localForm.ihse = this.getDetail.char.ihse;
    this.localForm.ifin = this.getDetail.char.ifin;
    this.localForm.impact = this.getDetail.char.impact;

    this.orgForm.isoc = this.getDetail.char.isoc;
    this.orgForm.irep = this.getDetail.char.irep;
    this.orgForm.ifin = this.getDetail.char.ifin;
    this.orgForm.ibus = this.getDetail.char.ibus;
    this.orgForm.ihse = this.getDetail.char.ihse;
    this.orgForm.ienv = this.getDetail.char.ienv;
    this.orgForm.impact = this.getDetail.char.impact;

    this.barrier = this.getDetailRelps.s3;
    this.control = this.getDetailRelps.s4;
    this.outcome = this.getDetailRelps.s5;
  },
  watch: {
    barrier() {
      this.localForm.barrier = this.barrier;
      this.updateFormRelps();
    },
    control() {
      this.localForm.control = this.control;
      this.updateFormRelps();
    },
    outcome() {
      this.localForm.outcome = this.outcome;
      this.updateFormRelps();
    },
    ibus() {
      this.localForm.ibus = this.ibus;
      this.updateFormChar();
    },
    ihse() {
      this.localForm.ihse = this.ihse;
      this.updateFormChar();
    },
    ienv() {
      this.localForm.ienv = this.ienv;
      this.updateFormChar();
    },
    ifin() {
      this.localForm.ifin = this.ifin;
      this.updateFormChar();
    },
    isoc() {
      this.localForm.isoc = this.isoc;
      this.updateFormChar();
    },
    irep() {
      this.localForm.irep = this.irep;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    incidentOptions,
    riskOptions,
    hazardOptions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailRelps",
      "getCurrentPage"
    ]),
    enableEventBarriersControls() {
      let logic = null;
      if (
        this.getDetailBasic.tag !== "B6" &&
        this.getDetailBasic.tag !== "E2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableEscalationOutcomes() {
      let logic = null;
      if (
        this.getDetailBasic.tag !== "B6" &&
        this.getDetailBasic.tag !== "E2" &&
        this.getDetailBasic.tag !== "M2"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    // title() {
    //   let title = null;
    //   if (this.getDetail.basic.tag === "S6") {
    //     title = "Incident Event Impacts";
    //   } else if (this.getDetail.basic.tag === "F1") {
    //     title = "Facility Impacts on Community";
    //   } else {
    //     title = "Busienss Impacts";
    //   }
    //   return title;
    // },
    impactObj() {
      let obj = {
        titleImpact: "Busienss Impacts",
        titleControl: "Event Barriers and Controls",
        titleDescription: "Impact and Escalation",
        titleOutcome: "Potential Escalation Outcomes"
      };
      if (this.getDetailBasic.tag === "B1") {
        obj.titleImpact = "Risk Impacts";
        obj.titleControl = "Risk Barriers and Controls";
        obj.titleDescription = "Risk Scenario Escalation";
        obj.titleOutcome = "Potential Risk Outcomes";
      }
      if (this.getDetailBasic.tag === "F1") {
        obj.titleImpact = "Facility Operations Impacts";
        obj.titleControl = "Operations Risk Barriers and Controls";
        obj.titleDescription = "Faciliy Risks and Impacts";
        obj.titleOutcome = "Potential Facility Risks Outcomes";
      }
      if (this.getDetailBasic.tag === "M2") {
        obj.titleImpact = "Maintenance Execution Impacts";
        obj.titleControl = "Impacted Barriers and Controls";
        obj.titleDescription = "Maintenance Execution Risks";
        obj.titleOutcome = "Potential Risk Outcomes";
      }
      if (this.getDetailBasic.tag === "M5") {
        obj.titleImpact = "Maintenance Plan Impacts";
        obj.titleControl = "Impacted Barriers and Controls";
        obj.titleDescription = "Maintenance Execution Risks";
        obj.titleOutcome = "Potential Risk Outcomes";
      }
      if (this.getDetailBasic.tag === "S6") {
        obj.titleImpact = "Incident Event Impacts";
      }
      if (this.getDetailBasic.tag === "W1") {
        obj.titleImpact = "Work Activity Impacts";
        obj.titleControl = "Work Risk Barriers and Controls";
        obj.titleDescription = "Work Risks and Impacts";
        obj.titleOutcome = "Work Execution Risks";
      }
      return obj;
    }
  },
  methods: {
    updateFormRelps() {
      let relps = this.getDetailRelps;
      // not applicable to PLAN
      if (
        this.getDetailBasic.tag === "B1" ||
        this.getDetailBasic.tag === "F1" ||
        this.getDetailBasic.tag === "S6" ||
        this.getDetailBasic.tag === "W1" ||
        this.getDetailBasic.tag === "M5"
      ) {
        relps.s3 = this.barrier;
        relps.s4 = this.control;
        relps.s5 = this.outcome;

        // when loaded first time ctr is = 1 as s3 / s4 load
        if (this.ctr > 2) {
          this.$store.dispatch("changeDataSavePendingIndication", true);
          this.$store.dispatch("changeDetailRelps", relps);
          this.saveDocumentRevMod(4.17, 1); // business mod.
        }
        // This conter ensure that the Hazard Contrl does not fire
        //  in the first page show
        this.ctr = this.ctr + 1;
      }
      if (this.getDetailBasic.tag === "M2") {
        relps.s3 = this.barrier;
        relps.s4 = this.control;

        // when loaded first time ctr is = 1 as s3 / s4 load
        if (this.ctr > 2) {
          this.$store.dispatch("changeDataSavePendingIndication", true);
          this.$store.dispatch("changeDetailRelps", relps);
          this.saveDocumentRevMod(4.17, 1); // business mod.
        }
        // This conter ensure that the Hazard Contrl does not fire
        //  in the first page show
        this.ctr = this.ctr + 1;
      }
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.ienv !== this.orgForm.ienv &&
        this.localForm.ienv !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ienv = this.localForm.ienv;
        // basic
        char.ienv = this.localForm.ienv;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ihse !== this.orgForm.ihse &&
        this.localForm.ihse !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ihse = this.localForm.ihse;
        // basic
        char.ihse = this.localForm.ihse;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ifin !== this.orgForm.ifin &&
        this.localForm.ifin !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ifin = this.localForm.ifin;
        // basic
        char.ifin = this.localForm.ifin;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ibus !== this.orgForm.ibus &&
        this.localForm.ibus !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ibus = this.localForm.ibus;
        // basic
        char.ibus = this.localForm.ibus;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.impact !== this.orgForm.impact &&
        this.localForm.impact !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.impact = this.localForm.impact;
        // basic
        char.impact = this.localForm.impact;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.isoc !== this.orgForm.isoc &&
        this.localForm.isoc !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.isoc = this.localForm.isoc;
        // basic
        char.isoc = this.localForm.isoc;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.irep !== this.orgForm.irep &&
        this.localForm.irep !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.irep = this.localForm.irep;
        // basic
        char.irep = this.localForm.irep;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
